// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3tu5j","box":"WorkspacesBox_box__JMfvX","node":"WorkspacesBox_node__1BcqS"};